// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg fill=%27white%27 height=%2714%27 viewBox=%270 0 24 24%27 width=%2714%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Layout & Background ---------- */
.signup-section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  font-family: 'Poppins', sans-serif;
  padding: 2rem 1rem;
}


/* .signup-container {
  display: block !important;
} */

/* .signup-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 2rem;
} */
/* ─── Mobile responsiveness ─── */
@media (max-width: 768px) {
  .signup-section {
    padding: 2rem 1rem;
  }
  .signup-container {
    margin: 0 1rem;
    padding: 1rem !important;
  }
  .signup-content {
    grid-template-columns: 1fr !important;
    gap: 1.5rem;
  }
  /* .marketing-panel,
  .form-panel {
    padding: 1rem !important;
  } */
}


/* ---------- Marketing Panel ---------- */
/* .marketing-panel {
  padding: 2.5rem 2rem 1rem;
}
.marketing-panel h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #2bb8dd;
  margin-bottom: 0.5rem;
}
.marketing-panel .marketing-subhead {
  font-size: 1rem;
  color: #94a3b8;
  margin-bottom: 0.75rem;
}
.marketing-panel .benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.marketing-panel .benefits-list li {
  position: relative;
  padding-left: 1.4em;
  margin-bottom: 0.5em;
  font-size: 1rem;
  color: #e2e8f0;
} */
/* .marketing-panel .benefits-list li::before {
  content: '';
  position: absolute;
  top: 0.4em;
  left: 0;
  width: 8px;
  height: 8px;
  background: #2bb8dd;
  border-radius: 50%;
} */
/* .marketing-panel::after {
  content: '';
  display: block;
  width: 60%;
  height: 1px;
  background: rgba(43, 184, 221, 0.3);
  margin: 0.75rem auto 0;
} */

/* ---------- Form Panel ---------- */
.form-panel {
  padding: 1rem 2rem;
}
.form-panel h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0.5rem 0 0.75rem;
}

/* ---------- Form & Inputs ---------- */
.signup-form {
  max-width: 600px;
  margin: 0 auto;
}
.signup-form .form-group {
  position: relative;
  margin-bottom: 0.5rem !important;
}
/* visually hide default labels */
.signup-form label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  white-space: nowrap;
  border: 0;
}
/* two-column layouts on desktop */
@media (min-width: 768px) {
  .signup-form .two-col {
    display: flex;
    gap: 1rem;
  }
}
/* text-like inputs (exclude checkbox) */
.signup-form input:not([type="checkbox"]),
.signup-form select {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 0.25rem !important;
  border: 2px solid #374151;
  border-radius: 10px;
  font-size: 1.1rem;
  background: rgba(30, 41, 59, 0.5);
  color: #f1f5f9;
  transition: all 0.3s ease;
}
.signup-form input:not([type="checkbox"]):focus,
.signup-form select:focus {
  border-color: #2bb8dd;
  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);
  outline: none;
}

/* ---------- Error Messages ---------- */
.error-message {
  color: #f87171;
  font-size: 0.9rem;
  margin: 0.5rem 0;
  text-align: center;
}
.error-message.small {
  text-align: left;
  margin: 0.25rem 0 1rem;
}

/* ---------- Buttons ---------- */
.signup-btn {
  width: 100%;
  padding: 12px 0;
  margin-top: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: background 0.3s, transform 0.2s, box-shadow 0.2s;
}
.signup-btn:hover:not(:disabled) {
  background: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
.signup-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Dark Theme + Responsive + Modal Variables ── */
:root {
  --ae-primary:   #2BB8DD;
  --ae-dark-bg:   #0E1627;
  --ae-light:     #FFFFFF;
  --ae-error:     #FF4D4F;
  --ae-success:   #4BB543;
}

/* ── Section & container ── */
.signup-section {
  background: var(--ae-dark-bg);
  padding: 2rem 1rem;
}
.signup-container {
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  background: #0C1B32;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  padding: 3rem 2rem;
}


/* ── Marketing panel ── */
/* .marketing-panel {
  padding: 2rem;
  text-align: center;
} */
/* .marketing-panel h2 {
  color: var(--ae-primary);
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
} */
.marketing-subhead {
  color: rgba(255,255,255,0.85);
  font-size: 1rem;
  margin-bottom: 1rem;
}
/* .marketing-panel hr {
  border: none;
  border-top: 1px solid var(--ae-primary);
  width: 60px;
  margin: 1.5rem auto;
} */
.benefits-list {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
}
.benefits-list li {
  position: relative;
  padding-left: 1.5em;
  margin-bottom: 0.75em;
  color: var(--ae-light);
  font-size: 1rem;
}
.benefits-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.6em;
  width: 8px;
  height: 8px;
  background: var(--ae-primary);
  border-radius: 50%;
}

/* ── Form panel ── */
.form-panel {
  padding: 2rem;
  background: var(--ae-dark-bg);
}
.form-panel h2 {
  color: var(--ae-light);
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

/* Inputs & labels */
.signup-form {
  display: grid;
  row-gap: 1rem;
}
.signup-form label {
  color: var(--ae-light);
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  display: block;
}
.signup-form input {
  width: 100%;
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 6px;
  background: #0E1B35;
  color: var(--ae-light);
}
.signup-form input:focus {
  outline: none;
  border-color: var(--ae-primary);
  box-shadow: 0 0 0 3px rgba(43,184,221,0.3);
}

/* Two-col override */
@media (min-width: 768px) {
  .signup-form .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    row-gap: 1rem;
  }
}

/* Buttons */
.signup-btn,
.verify-btn {
  width: 100%;
  padding: 0.75rem;
  background: var(--ae-primary);
  border: none;
  border-radius: 6px;
  color: var(--ae-light);
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.signup-btn:hover:not(:disabled),
.verify-btn:hover {
  background: #26A7C9;
}
.signup-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Modal overlay & box */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14,22,39,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}
.modal-content {
  background: var(--ae-dark-bg);
  border: 2px solid var(--ae-primary);
  border-radius: 8px;
  color: var(--ae-light);
  max-width: 400px;
  width: 100%;
  padding: 1.5rem;
  position: relative;
  box-shadow: 0 8px 24px rgba(0,0,0,0.6);
}
.policy-modal {
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.4rem;
  color: var(--ae-light);
  cursor: pointer;
}
.modal-close-btn:hover {
  color: var(--ae-primary);
}
.modal-content h3 {
  margin-top: 0;
  color: var(--ae-primary);
  font-size: 1.4rem;
}
.modal-content p {
  margin: 0.75rem 0;
  line-height: 1.5;
}
.success-text {
  color: var(--ae-success);
  margin-top: 0.75rem;
}
.error-text,
.error-message {
  color: var(--ae-error);
  margin-top: 0.5rem;
}
.agreement-text a {
  color: var(--ae-primary);
  text-decoration: underline;
}
.agreement-text a:hover {
  color: #26A7C9;
}
.policy-modal,
.policy-modal .policy-text {
  background: var(--ae-dark-bg)!important;
  color: var(--ae-light)!important;
  padding: 1.5rem;
  line-height: 1.6;
}
.policy-modal .policy-text h3,
.policy-modal .policy-text strong {
  color: var(--ae-primary)!important;
}
.policy-modal .policy-text p,
.policy-modal .policy-text li {
  color: rgba(255,255,255,0.85)!important;
}
.policy-modal::-webkit-scrollbar {
  width: 6px;
}
.policy-modal::-webkit-scrollbar-thumb {
  background: var(--ae-primary);
  border-radius: 3px;
}
.policy-modal::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.1);
}
/* ==============================
   Admissions Express Additional Fields
============================== */

.signup-form select,
.signup-form .other-input {
  width: 100%;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 1.05rem;
  border: 2px solid #374151;
  background: rgba(30, 41, 59, 0.5);
  color: blue;
  transition: all 0.3s ease;
  appearance: none; /* remove default arrow */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
}

.signup-form select:focus,
.signup-form .other-input:focus {
  border-color: var(--ae-primary);
  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.25);
  outline: none;
}

.signup-form select option {
  background: #0E1B35;
  color: #ffffff;
}

/* ======================================
   ✈ Plane + Cloud Motion (Behind Buttons)
====================================== */

.cta-section {
  position: relative;
  overflow: hidden;
}

/* --- Clouds (slow motion, ambient feel) --- */
.cloud {
  position: absolute;
  bottom: 0;
  width: 180px;
  height: 60px;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 70%,
    transparent 100%
  );
  border-radius: 50%;
  filter: blur(6px);
  animation: cloudDrift 20s linear infinite;
  z-index: 1;
}

.cloud-left {
  left: 10%;
  animation-delay: 0s;
}

.cloud-right {
  right: 10%;
  animation-delay: 8s;
}

@keyframes cloudDrift {
  0% {
    transform: translateX(-30px);
    opacity: 0.4;
  }
  50% {
    transform: translateX(30px);
    opacity: 0.6;
  }
  100% {
    transform: translateX(-30px);
    opacity: 0.4;
  }
}

/* --- Plane behind buttons --- */
.plane-wrapper.behind {
  position: absolute;
  bottom: -120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;
}

/* --- Plane --- */
.plane-up {
  width: 90px;
  opacity: 0;
  animation: flyUpStraight 7s ease-in-out infinite;
}

/* --- Air Trail --- */
.air-trail {
  position: absolute;
  bottom: -20px;
  left: 50%;
  width: 6px;
  height: 90px;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.3), transparent);
  border-radius: 3px;
  transform: translateX(-50%);
  opacity: 0;
  animation: trailFade 7s ease-in-out infinite;
}

/* --- Plane upward animation --- */
@keyframes flyUpStraight {
  0% {
    opacity: 0;
    transform: translateY(0) scale(0.9) rotate(0deg);
  }
  10% {
    opacity: 1;
  }
  50% {
    transform: translateY(-200px) scale(1) rotate(-3deg);
    opacity: 1;
  }
  80% {
    transform: translateY(-400px) scale(1.1) rotate(-6deg);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-600px) scale(1.2) rotate(-8deg);
    opacity: 0;
  }
}

/* --- Air trail fade --- */
@keyframes trailFade {
  0% {
    opacity: 0;
    height: 0;
  }
  20% {
    opacity: 0.6;
    height: 90px;
  }
  80% {
    opacity: 0.3;
    height: 120px;
  }
  100% {
    opacity: 0;
    height: 0;
  }
}

/* keep buttons above plane */
.cta-buttons {
  position: relative;
  z-index: 5;
}

/* smooth slide-in for “Other” input */
.other-input {
  margin-top: 10px;
  opacity: 0;
  transform: translateY(-5px);
  animation: fadeIn 0.3s forwards;
}
@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* mobile tweaks */
@media (max-width: 768px) {
  .signup-form select,
  .signup-form .other-input {
    font-size: 0.95rem;
    padding: 10px 14px;
  }
}


/* Responsive */
@media (max-width: 768px) {
  .form-panel {
    padding: 1rem;
  }
  .modal-content {
    padding: 1.5rem;
  }
  .modal-close-btn {
    top: 0.75rem;
    right: 0.75rem;
  }
}
/* ==============================
   CTA Section (Admissions Express)
============================== */
.cta-section {
  background-color: #0b1120; /* your dark theme */
  color: #ffffff;
  text-align: center;
  padding: 120px 20px; /* taller height */
  border-top: 2px solid #17324d;
  border-bottom: 2px solid #17324d;
  position: relative;
}

.cta-title {
  font-size: 2.6rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
}

.cta-title .highlight {
  color: #00bfff; /* matches your blue accent */
}

.cta-text {
  font-size: 1.1rem;
  color: #bfc7d1;
  max-width: 780px;
  margin: 0 auto 45px;
  line-height: 1.7;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 18px;
}

/* --- Buttons --- */
.cta-btn {
  padding: 14px 38px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.05rem;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 190px;
  cursor: pointer;
  border: none;
}

/* Primary CTA (Bright Blue) */
.cta-primary {
  background-color: #00bfff; /* your site’s button blue */
  color: #fff;
}

.cta-primary:hover {
  background-color: #12a5e6;
  transform: translateY(-2px);
}

/* Secondary CTA (Outline) */
.cta-secondary {
  border: 2px solid #00bfff;
  background-color: transparent;
  color: #00bfff;
}

.cta-secondary:hover {
  background-color: #00bfff;
  color: #fff;
  transform: translateY(-2px);
}

/* --- Responsive Layout --- */
@media (max-width: 992px) {
  .cta-title {
    font-size: 2rem;
  }
  .cta-text {
    font-size: 1rem;
    max-width: 650px;
  }
}

@media (max-width: 576px) {
  .cta-section {
    padding: 80px 15px;
  }
  .cta-title {
    font-size: 1.7rem;
    line-height: 1.4;
  }
  .cta-text {
    font-size: 0.95rem;
    margin-bottom: 35px;
  }
  .cta-buttons {
    flex-direction: column;
    gap: 14px;
  }
  .cta-btn {
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
  }
}

















/* ======================================
   FIX: Center the form perfectly
====================================== */
.signup-section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  font-family: 'Poppins', sans-serif;
  padding: 2rem 1rem;
}

/* Center container and make it a nice card */
.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  width: 100%;
  background: #0C1B32;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  padding: 3rem 2rem;
  margin: 0 auto;
}

/* Align heading centrally */
.form-panel h2 {
  text-align: center;
  color: var(--ae-primary);
  font-size: 1.9rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

/* Make sure inputs and buttons stretch full width */
.signup-form {
  width: 100%;
}
/* ==============================
   CTA SECTION BASE
============================== */

.cta-section {
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #050b1d, #0b1120);
  padding: 120px 20px;
  color: #ffffff;
  text-align: center;
}

/* ==============================
   CLOUDS (TOP LAYER)
============================== */

.cta-cloud {
  position: absolute;
  top: 40px;
  width: 220px;
  opacity: 0.15;
  z-index: 1;
  filter: blur(1px);
}

.cloud-left {
  left: -40px;
}

.cloud-right {
  right: -40px;
}

/* ==============================
   VISUAL LAYER
============================== */

.cta-visuals {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}

/* Statue */
.cta-statue {
  position: absolute;
  bottom: -20px;
  right: 40px;
  width: 320px;
  opacity: 0.25;
  filter: grayscale(100%) brightness(0.9);
}

/* Plane */
.cta-plane {
  position: absolute;
  left: -120px;
  bottom: 180px;
  width: 110px;
  opacity: 0.35;
  transform-origin: center;
  transition: transform 0.1s linear;
  filter: brightness(0.8);
}

/* ==============================
   CONTENT ABOVE VISUALS
============================== */

.cta-section .container {
  position: relative;
  z-index: 5;
}

.cta-title {
  font-size: 2.6rem;
  font-weight: 700;
  margin-bottom: 20px;
}

.cta-text {
  font-size: 1.1rem;
  color: #bfc7d1;
  max-width: 780px;
  margin: 0 auto 45px;
  line-height: 1.7;
}

/* Buttons */
.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 18px;
}

.cta-btn {
  padding: 14px 38px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.05rem;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 190px;
}

.cta-primary {
  background: #00bfff;
  color: #fff;
}

.cta-primary:hover {
  background: #12a5e6;
  transform: translateY(-2px);
}

.cta-secondary {
  border: 2px solid #00bfff;
  color: #00bfff;
}

.cta-secondary:hover {
  background: #00bfff;
  color: #fff;
}

/* ==============================
   MOBILE VIEW
============================== */
@media (max-width: 768px) {
  .cta-section {
    padding: 90px 16px;
    position: relative; /* REQUIRED */
    overflow: hidden;   /* optional, keeps statue inside */
  }

  .cta-statue {
    position: absolute;
    bottom: 0;          /* stick to bottom */
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 420px;
    opacity: 0.12;
    pointer-events: none;
  }

  .cta-plane {
    display: none;
  }

  .cta-cloud {
    opacity: 0.08;
  }

  .cta-buttons {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SignupForm/SignupForm.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,kCAAkC;EAClC,kBAAkB;AACpB;;;AAGA;;GAEG;;AAEH;;;;;GAKG;AACH,kCAAkC;AAClC;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,qCAAqC;IACrC,WAAW;EACb;EACA;;;KAGG;AACL;;;AAGA,0CAA0C;AAC1C;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;AACH;;;;;;;;;GASG;AACH;;;;;;;GAOG;;AAEH,qCAAqC;AACrC;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,SAAS;EACX;AACF;AACA,wCAAwC;AACxC;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,4DAA4D;AAC9D;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;;AAGA,0BAA0B;AAC1B;;;GAGG;AACH;;;;GAIG;AACH;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;AACA;;;;;GAKG;AACH;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA,YAAY;AACZ;;EAEE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;;gCAEgC;;AAEhC;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;EACX,yBAAyB;EACzB,gBAAgB,EAAE,yBAAyB;EAC3C,yDAAwL;EACxL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;EAC/B,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;wCAEwC;;AAExC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ;;;;;GAKC;EACD,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,UAAU;EACV,gDAAgD;AAClD;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0EAA0E;EAC1E,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,gDAAgD;EAClD;EACA;IACE,UAAU;EACZ;EACA;IACE,oDAAoD;IACpD,UAAU;EACZ;EACA;IACE,sDAAsD;IACtD,YAAY;EACd;EACA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;;AAGA,eAAe;AACf;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;AACF;AACA;;gCAEgC;AAChC;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc;EACd,kBAAkB;EAClB,mBAAmB,EAAE,kBAAkB;EACvC,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB,EAAE,4BAA4B;EACvD,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;AACF;;;;;;;;;;;;;;;;;;AAkBA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,WAAW;AACb;AACA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;gCAEgC;;AAEhC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;gCAEgC;AAChC;EACE;IACE,kBAAkB;IAClB,kBAAkB,EAAE,aAAa;IACjC,gBAAgB,IAAI,kCAAkC;EACxD;;EAEA;IACE,kBAAkB;IAClB,SAAS,WAAW,oBAAoB;IACxC,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ---------- Layout & Background ---------- */\n.signup-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  font-family: 'Poppins', sans-serif;\n  padding: 2rem 1rem;\n}\n\n\n/* .signup-container {\n  display: block !important;\n} */\n\n/* .signup-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: start;\n  gap: 2rem;\n} */\n/* ─── Mobile responsiveness ─── */\n@media (max-width: 768px) {\n  .signup-section {\n    padding: 2rem 1rem;\n  }\n  .signup-container {\n    margin: 0 1rem;\n    padding: 1rem !important;\n  }\n  .signup-content {\n    grid-template-columns: 1fr !important;\n    gap: 1.5rem;\n  }\n  /* .marketing-panel,\n  .form-panel {\n    padding: 1rem !important;\n  } */\n}\n\n\n/* ---------- Marketing Panel ---------- */\n/* .marketing-panel {\n  padding: 2.5rem 2rem 1rem;\n}\n.marketing-panel h2 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #2bb8dd;\n  margin-bottom: 0.5rem;\n}\n.marketing-panel .marketing-subhead {\n  font-size: 1rem;\n  color: #94a3b8;\n  margin-bottom: 0.75rem;\n}\n.marketing-panel .benefits-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.marketing-panel .benefits-list li {\n  position: relative;\n  padding-left: 1.4em;\n  margin-bottom: 0.5em;\n  font-size: 1rem;\n  color: #e2e8f0;\n} */\n/* .marketing-panel .benefits-list li::before {\n  content: '';\n  position: absolute;\n  top: 0.4em;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: #2bb8dd;\n  border-radius: 50%;\n} */\n/* .marketing-panel::after {\n  content: '';\n  display: block;\n  width: 60%;\n  height: 1px;\n  background: rgba(43, 184, 221, 0.3);\n  margin: 0.75rem auto 0;\n} */\n\n/* ---------- Form Panel ---------- */\n.form-panel {\n  padding: 1rem 2rem;\n}\n.form-panel h2 {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0.5rem 0 0.75rem;\n}\n\n/* ---------- Form & Inputs ---------- */\n.signup-form {\n  max-width: 600px;\n  margin: 0 auto;\n}\n.signup-form .form-group {\n  position: relative;\n  margin-bottom: 0.5rem !important;\n}\n/* visually hide default labels */\n.signup-form label {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  white-space: nowrap;\n  border: 0;\n}\n/* two-column layouts on desktop */\n@media (min-width: 768px) {\n  .signup-form .two-col {\n    display: flex;\n    gap: 1rem;\n  }\n}\n/* text-like inputs (exclude checkbox) */\n.signup-form input:not([type=\"checkbox\"]),\n.signup-form select {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 0.25rem !important;\n  border: 2px solid #374151;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  background: rgba(30, 41, 59, 0.5);\n  color: #f1f5f9;\n  transition: all 0.3s ease;\n}\n.signup-form input:not([type=\"checkbox\"]):focus,\n.signup-form select:focus {\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);\n  outline: none;\n}\n\n/* ---------- Error Messages ---------- */\n.error-message {\n  color: #f87171;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n  text-align: center;\n}\n.error-message.small {\n  text-align: left;\n  margin: 0.25rem 0 1rem;\n}\n\n/* ---------- Buttons ---------- */\n.signup-btn {\n  width: 100%;\n  padding: 12px 0;\n  margin-top: 1rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: background 0.3s, transform 0.2s, box-shadow 0.2s;\n}\n.signup-btn:hover:not(:disabled) {\n  background: #1e40af;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n}\n.signup-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ── Dark Theme + Responsive + Modal Variables ── */\n:root {\n  --ae-primary:   #2BB8DD;\n  --ae-dark-bg:   #0E1627;\n  --ae-light:     #FFFFFF;\n  --ae-error:     #FF4D4F;\n  --ae-success:   #4BB543;\n}\n\n/* ── Section & container ── */\n.signup-section {\n  background: var(--ae-dark-bg);\n  padding: 2rem 1rem;\n}\n.signup-container {\n  max-width: 600px;\n  width: 100%;\n  margin: 0 auto;\n  background: #0C1B32;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  padding: 3rem 2rem;\n}\n\n\n/* ── Marketing panel ── */\n/* .marketing-panel {\n  padding: 2rem;\n  text-align: center;\n} */\n/* .marketing-panel h2 {\n  color: var(--ae-primary);\n  font-size: 1.75rem;\n  margin-bottom: 0.5rem;\n} */\n.marketing-subhead {\n  color: rgba(255,255,255,0.85);\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n/* .marketing-panel hr {\n  border: none;\n  border-top: 1px solid var(--ae-primary);\n  width: 60px;\n  margin: 1.5rem auto;\n} */\n.benefits-list {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0;\n}\n.benefits-list li {\n  position: relative;\n  padding-left: 1.5em;\n  margin-bottom: 0.75em;\n  color: var(--ae-light);\n  font-size: 1rem;\n}\n.benefits-list li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0.6em;\n  width: 8px;\n  height: 8px;\n  background: var(--ae-primary);\n  border-radius: 50%;\n}\n\n/* ── Form panel ── */\n.form-panel {\n  padding: 2rem;\n  background: var(--ae-dark-bg);\n}\n.form-panel h2 {\n  color: var(--ae-light);\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Inputs & labels */\n.signup-form {\n  display: grid;\n  row-gap: 1rem;\n}\n.signup-form label {\n  color: var(--ae-light);\n  font-size: 0.9rem;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n.signup-form input {\n  width: 100%;\n  padding: 0.6rem;\n  margin-bottom: 1rem;\n  border: 1px solid rgba(255,255,255,0.2);\n  border-radius: 6px;\n  background: #0E1B35;\n  color: var(--ae-light);\n}\n.signup-form input:focus {\n  outline: none;\n  border-color: var(--ae-primary);\n  box-shadow: 0 0 0 3px rgba(43,184,221,0.3);\n}\n\n/* Two-col override */\n@media (min-width: 768px) {\n  .signup-form .two-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 1rem;\n    row-gap: 1rem;\n  }\n}\n\n/* Buttons */\n.signup-btn,\n.verify-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background: var(--ae-primary);\n  border: none;\n  border-radius: 6px;\n  color: var(--ae-light);\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.signup-btn:hover:not(:disabled),\n.verify-btn:hover {\n  background: #26A7C9;\n}\n.signup-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Modal overlay & box */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(14,22,39,0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 1rem;\n}\n.modal-content {\n  background: var(--ae-dark-bg);\n  border: 2px solid var(--ae-primary);\n  border-radius: 8px;\n  color: var(--ae-light);\n  max-width: 400px;\n  width: 100%;\n  padding: 1.5rem;\n  position: relative;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.6);\n}\n.policy-modal {\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n.modal-close-btn {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  color: var(--ae-light);\n  cursor: pointer;\n}\n.modal-close-btn:hover {\n  color: var(--ae-primary);\n}\n.modal-content h3 {\n  margin-top: 0;\n  color: var(--ae-primary);\n  font-size: 1.4rem;\n}\n.modal-content p {\n  margin: 0.75rem 0;\n  line-height: 1.5;\n}\n.success-text {\n  color: var(--ae-success);\n  margin-top: 0.75rem;\n}\n.error-text,\n.error-message {\n  color: var(--ae-error);\n  margin-top: 0.5rem;\n}\n.agreement-text a {\n  color: var(--ae-primary);\n  text-decoration: underline;\n}\n.agreement-text a:hover {\n  color: #26A7C9;\n}\n.policy-modal,\n.policy-modal .policy-text {\n  background: var(--ae-dark-bg)!important;\n  color: var(--ae-light)!important;\n  padding: 1.5rem;\n  line-height: 1.6;\n}\n.policy-modal .policy-text h3,\n.policy-modal .policy-text strong {\n  color: var(--ae-primary)!important;\n}\n.policy-modal .policy-text p,\n.policy-modal .policy-text li {\n  color: rgba(255,255,255,0.85)!important;\n}\n.policy-modal::-webkit-scrollbar {\n  width: 6px;\n}\n.policy-modal::-webkit-scrollbar-thumb {\n  background: var(--ae-primary);\n  border-radius: 3px;\n}\n.policy-modal::-webkit-scrollbar-track {\n  background: rgba(255,255,255,0.1);\n}\n/* ==============================\n   Admissions Express Additional Fields\n============================== */\n\n.signup-form select,\n.signup-form .other-input {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 1.05rem;\n  border: 2px solid #374151;\n  background: rgba(30, 41, 59, 0.5);\n  color: blue;\n  transition: all 0.3s ease;\n  appearance: none; /* remove default arrow */\n  background-image: url(\"data:image/svg+xml,%3Csvg fill='white' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 14px;\n}\n\n.signup-form select:focus,\n.signup-form .other-input:focus {\n  border-color: var(--ae-primary);\n  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.25);\n  outline: none;\n}\n\n.signup-form select option {\n  background: #0E1B35;\n  color: #ffffff;\n}\n\n/* ======================================\n   ✈ Plane + Cloud Motion (Behind Buttons)\n====================================== */\n\n.cta-section {\n  position: relative;\n  overflow: hidden;\n}\n\n/* --- Clouds (slow motion, ambient feel) --- */\n.cloud {\n  position: absolute;\n  bottom: 0;\n  width: 180px;\n  height: 60px;\n  background: radial-gradient(\n    circle at 30% 30%,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.05) 70%,\n    transparent 100%\n  );\n  border-radius: 50%;\n  filter: blur(6px);\n  animation: cloudDrift 20s linear infinite;\n  z-index: 1;\n}\n\n.cloud-left {\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.cloud-right {\n  right: 10%;\n  animation-delay: 8s;\n}\n\n@keyframes cloudDrift {\n  0% {\n    transform: translateX(-30px);\n    opacity: 0.4;\n  }\n  50% {\n    transform: translateX(30px);\n    opacity: 0.6;\n  }\n  100% {\n    transform: translateX(-30px);\n    opacity: 0.4;\n  }\n}\n\n/* --- Plane behind buttons --- */\n.plane-wrapper.behind {\n  position: absolute;\n  bottom: -120px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  pointer-events: none;\n}\n\n/* --- Plane --- */\n.plane-up {\n  width: 90px;\n  opacity: 0;\n  animation: flyUpStraight 7s ease-in-out infinite;\n}\n\n/* --- Air Trail --- */\n.air-trail {\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  width: 6px;\n  height: 90px;\n  background: linear-gradient(to top, rgba(255, 255, 255, 0.3), transparent);\n  border-radius: 3px;\n  transform: translateX(-50%);\n  opacity: 0;\n  animation: trailFade 7s ease-in-out infinite;\n}\n\n/* --- Plane upward animation --- */\n@keyframes flyUpStraight {\n  0% {\n    opacity: 0;\n    transform: translateY(0) scale(0.9) rotate(0deg);\n  }\n  10% {\n    opacity: 1;\n  }\n  50% {\n    transform: translateY(-200px) scale(1) rotate(-3deg);\n    opacity: 1;\n  }\n  80% {\n    transform: translateY(-400px) scale(1.1) rotate(-6deg);\n    opacity: 0.8;\n  }\n  100% {\n    transform: translateY(-600px) scale(1.2) rotate(-8deg);\n    opacity: 0;\n  }\n}\n\n/* --- Air trail fade --- */\n@keyframes trailFade {\n  0% {\n    opacity: 0;\n    height: 0;\n  }\n  20% {\n    opacity: 0.6;\n    height: 90px;\n  }\n  80% {\n    opacity: 0.3;\n    height: 120px;\n  }\n  100% {\n    opacity: 0;\n    height: 0;\n  }\n}\n\n/* keep buttons above plane */\n.cta-buttons {\n  position: relative;\n  z-index: 5;\n}\n\n/* smooth slide-in for “Other” input */\n.other-input {\n  margin-top: 10px;\n  opacity: 0;\n  transform: translateY(-5px);\n  animation: fadeIn 0.3s forwards;\n}\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* mobile tweaks */\n@media (max-width: 768px) {\n  .signup-form select,\n  .signup-form .other-input {\n    font-size: 0.95rem;\n    padding: 10px 14px;\n  }\n}\n\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-panel {\n    padding: 1rem;\n  }\n  .modal-content {\n    padding: 1.5rem;\n  }\n  .modal-close-btn {\n    top: 0.75rem;\n    right: 0.75rem;\n  }\n}\n/* ==============================\n   CTA Section (Admissions Express)\n============================== */\n.cta-section {\n  background-color: #0b1120; /* your dark theme */\n  color: #ffffff;\n  text-align: center;\n  padding: 120px 20px; /* taller height */\n  border-top: 2px solid #17324d;\n  border-bottom: 2px solid #17324d;\n  position: relative;\n}\n\n.cta-title {\n  font-size: 2.6rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 20px;\n  letter-spacing: 0.5px;\n}\n\n.cta-title .highlight {\n  color: #00bfff; /* matches your blue accent */\n}\n\n.cta-text {\n  font-size: 1.1rem;\n  color: #bfc7d1;\n  max-width: 780px;\n  margin: 0 auto 45px;\n  line-height: 1.7;\n}\n\n.cta-buttons {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 18px;\n}\n\n/* --- Buttons --- */\n.cta-btn {\n  padding: 14px 38px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 1.05rem;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  min-width: 190px;\n  cursor: pointer;\n  border: none;\n}\n\n/* Primary CTA (Bright Blue) */\n.cta-primary {\n  background-color: #00bfff; /* your site’s button blue */\n  color: #fff;\n}\n\n.cta-primary:hover {\n  background-color: #12a5e6;\n  transform: translateY(-2px);\n}\n\n/* Secondary CTA (Outline) */\n.cta-secondary {\n  border: 2px solid #00bfff;\n  background-color: transparent;\n  color: #00bfff;\n}\n\n.cta-secondary:hover {\n  background-color: #00bfff;\n  color: #fff;\n  transform: translateY(-2px);\n}\n\n/* --- Responsive Layout --- */\n@media (max-width: 992px) {\n  .cta-title {\n    font-size: 2rem;\n  }\n  .cta-text {\n    font-size: 1rem;\n    max-width: 650px;\n  }\n}\n\n@media (max-width: 576px) {\n  .cta-section {\n    padding: 80px 15px;\n  }\n  .cta-title {\n    font-size: 1.7rem;\n    line-height: 1.4;\n  }\n  .cta-text {\n    font-size: 0.95rem;\n    margin-bottom: 35px;\n  }\n  .cta-buttons {\n    flex-direction: column;\n    gap: 14px;\n  }\n  .cta-btn {\n    width: 100%;\n    max-width: 280px;\n    margin: 0 auto;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ======================================\n   FIX: Center the form perfectly\n====================================== */\n.signup-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  font-family: 'Poppins', sans-serif;\n  padding: 2rem 1rem;\n}\n\n/* Center container and make it a nice card */\n.signup-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 600px;\n  width: 100%;\n  background: #0C1B32;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  padding: 3rem 2rem;\n  margin: 0 auto;\n}\n\n/* Align heading centrally */\n.form-panel h2 {\n  text-align: center;\n  color: var(--ae-primary);\n  font-size: 1.9rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n/* Make sure inputs and buttons stretch full width */\n.signup-form {\n  width: 100%;\n}\n/* ==============================\n   CTA SECTION BASE\n============================== */\n\n.cta-section {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(180deg, #050b1d, #0b1120);\n  padding: 120px 20px;\n  color: #ffffff;\n  text-align: center;\n}\n\n/* ==============================\n   CLOUDS (TOP LAYER)\n============================== */\n\n.cta-cloud {\n  position: absolute;\n  top: 40px;\n  width: 220px;\n  opacity: 0.15;\n  z-index: 1;\n  filter: blur(1px);\n}\n\n.cloud-left {\n  left: -40px;\n}\n\n.cloud-right {\n  right: -40px;\n}\n\n/* ==============================\n   VISUAL LAYER\n============================== */\n\n.cta-visuals {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* Statue */\n.cta-statue {\n  position: absolute;\n  bottom: -20px;\n  right: 40px;\n  width: 320px;\n  opacity: 0.25;\n  filter: grayscale(100%) brightness(0.9);\n}\n\n/* Plane */\n.cta-plane {\n  position: absolute;\n  left: -120px;\n  bottom: 180px;\n  width: 110px;\n  opacity: 0.35;\n  transform-origin: center;\n  transition: transform 0.1s linear;\n  filter: brightness(0.8);\n}\n\n/* ==============================\n   CONTENT ABOVE VISUALS\n============================== */\n\n.cta-section .container {\n  position: relative;\n  z-index: 5;\n}\n\n.cta-title {\n  font-size: 2.6rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.cta-text {\n  font-size: 1.1rem;\n  color: #bfc7d1;\n  max-width: 780px;\n  margin: 0 auto 45px;\n  line-height: 1.7;\n}\n\n/* Buttons */\n.cta-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n}\n\n.cta-btn {\n  padding: 14px 38px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 1.05rem;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  min-width: 190px;\n}\n\n.cta-primary {\n  background: #00bfff;\n  color: #fff;\n}\n\n.cta-primary:hover {\n  background: #12a5e6;\n  transform: translateY(-2px);\n}\n\n.cta-secondary {\n  border: 2px solid #00bfff;\n  color: #00bfff;\n}\n\n.cta-secondary:hover {\n  background: #00bfff;\n  color: #fff;\n}\n\n/* ==============================\n   MOBILE VIEW\n============================== */\n@media (max-width: 768px) {\n  .cta-section {\n    padding: 90px 16px;\n    position: relative; /* REQUIRED */\n    overflow: hidden;   /* optional, keeps statue inside */\n  }\n\n  .cta-statue {\n    position: absolute;\n    bottom: 0;          /* stick to bottom */\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 420px;\n    opacity: 0.12;\n    pointer-events: none;\n  }\n\n  .cta-plane {\n    display: none;\n  }\n\n  .cta-cloud {\n    opacity: 0.08;\n  }\n\n  .cta-buttons {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
